import {
  Button,
  Form,
  Input,
  Typography,
  Modal,
  Card,
  Divider,
} from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { ArrowLeftOutlined } from "@ant-design/icons";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";
import BarcodeScanner from "../../Comman/Scanner/BarCodeScanner";
import "../../../styles/global-ui.css";

const { Title, Text } = Typography;

const GSMInward = ({ userData }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [scannedData, setScannedData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleTagClick = () => {
    setIsModalVisible(true);
  };

  const handleScan = (value) => {
    setIsModalVisible(false);
    onFinish({ binId: value });
  };

  const handleScanError = (error) => {
    ResponseMessage.error({
      message:
        "Error accessing camera. Please try manual input or check camera permissions.",
    });
    console.error(error);
  };

  const onFinish = async (values) => {
    try {
      const dataToSubmit = values.binId;
      setScannedData(dataToSubmit);

      if (!dataToSubmit) {
        ResponseMessage.error({
          message: "Please provide valid scanned data or enter it manually",
        });
        return;
      }

      setIsSubmitted(true);
      setIsLoading(true);
      navigate(`/gsm-bin-inward/confirm?binId=${encodeURIComponent(dataToSubmit)}`);
    } catch (error) {
      console.error("Error:", error);
      setIsLoading(false);
      ResponseMessage.error({
        message: "An error occurred while fetching data.",
      });
      setIsSubmitted(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Title level={3} className="page-title">
            <ArrowLeftOutlined
              style={{ marginRight: 10, cursor: "pointer" }}
              onClick={() => navigate("/gsm-bin-inward")}
            />
            Bin Inward
          </Title>
          <Text className="page-subtitle">
            Scan or enter a bin ID to continue inward process
          </Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card
        className="modern-card"
        style={{ maxWidth: 420, margin: "0 auto" }}
      >
        <div style={{ textAlign: "center" }}>
          <div
            className="dashboard-stat-card bg-card-blue"
            style={{ minHeight: 90 }}
            onClick={handleTagClick}
          >
            <div
              className="dashboard-stat-card-inner"
              style={{
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
              }}
            >
              <div className="dashboard-stat-title">SCAN BIN</div>
              <Text style={{ color: "#475569", fontSize: 13 }}>
                Tap to open scanner
              </Text>
            </div>
          </div>

          <Divider>OR</Divider>

          <Form
            name="form_item_path"
            layout="vertical"
            onFinish={onFinish}
            form={form}
          >
            <Form.Item
              name="binId"
              label="Enter Bin ID Manually"
              rules={[
                {
                  required: true,
                  message: "Bin ID cannot be empty. Please provide a valid ID.",
                },
              ]}
            >
              <Input
                autoFocus
                size="large"
                placeholder="Enter Bin ID"
                style={{ textAlign: "center" }}
                disabled={isLoading}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                className="primary-btn"
                loading={isLoading}
                disabled={isLoading}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Card>

      <Modal
        title="Scan Barcode"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <BarcodeScanner onScan={handleScan} onError={handleScanError} />
      </Modal>
    </div>
  );
};

export default GSMInward;